import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'chameleon/ui-stack/ui/toast';

import './styles.scss';

/**
 * This component is used to copy text to clipboard.
 * */
const CopyDetailsToClipboard = (props) => {
  const {
    customStyleClass,
    children,
    text,
    notificationText,
    notifyOnTextCopy,
  } = props;

  const onTextCopied = () => {
    notificationText && toast(notificationText, { timeout: 2 });
    notifyOnTextCopy && notifyOnTextCopy();
  };

  return (
    <CopyToClipboard
      text={text}
      onCopy={onTextCopied}
      options={{ format: 'text/plain' }}
    >
      <div
        className={cn('CopyDetailsToClipbaord', {
          [customStyleClass]: !!customStyleClass,
        })}
      >
        {children}
      </div>
    </CopyToClipboard>
  );
};

CopyDetailsToClipboard.displayname = 'CopyDetailsToClipboard';

CopyDetailsToClipboard.props = {
  // Parent class for styling purposes.
  customStyleClass: PropTypes.string,
  // Text to be copied to clipboard.
  text: PropTypes.string.isRequired,
  // Text for displaying as notification on text copy.
  notificationText: PropTypes.string,
  // Function handler for notify the parent on text copy.
  notifyOnTextCopy: PropTypes.func,
};

CopyDetailsToClipboard.defaultProps = {
  customStyleClass: null,
  notificationText: null,
  notifyOnTextCopy: () => {},
};

export default CopyDetailsToClipboard;
